import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorsReducer from './errorReducer';
import uiReducer from './uiReducer';
import alertsReducer from './alertsReducer';

import socketReducerCommon from './sockets/socketReducerCommon';
import socketReducerStudent from './sockets/socketReducerStudent';
import socketReducerTeacher from './sockets/socketReducerTeacher';

export default combineReducers({
  auth: authReducer,
  errors: errorsReducer,
  ui: uiReducer,
  alerts: alertsReducer,
  socketCommon: socketReducerCommon,
  socketStudent: socketReducerStudent,
  socketTeacher: socketReducerTeacher,
});
